<template lang="pug">
v-container.fill-height.pa-0.ma-0.wrapper-container(fluid)
  v-row(no-gutters style="max-width: 100%")
    v-col
      v-row.heading(
        v-if="headerText !== ''" 
        no-gutters 
        :justify="justifyRow"
        :style="[savedImgHeading ? { backgroundImage:`url(${savedImgHeading})`} : {}]"
      )
        v-col.col-text(:cols="8").d-flex.justify-center
          div.header-text {{ headerText }}
            p.subtitle-text.ma-0.pl-1 {{ subtitleText }}
      v-divider
      v-row(v-if="breadCrumbPath.length > 0" no-gutters :justify="justifyRow")
        v-col(cols=10)
          div.breadcrumbs
            BreadCrumbs(:bread-crumb-path="breadCrumbPath")
  div(:class="getSlotClass()")
    slot
</template>

<script>
import { mapFields } from "vuex-map-fields";
export default {
  name: "ContainerComponent",
  components: {
    BreadCrumbs: () => import("@/components/util/Breadcrumbs.vue"),
  },
  props: {
    breadCrumbPath: {
      type: Array,
      default: () => [],
    },
    headerText: {
      type: String,
      default: () => "",
    },
    removeSlotMargin: {
      type: Boolean,
      default: () => false,
    },
    fillHeight: {
      type: Boolean,
      default: () => false,
    },
    subtitleText: {
      type: String,
      default: () => "",
    },
  },
  computed: {
    ...mapFields("assets", ["savedImgHeading", "headingLoaded"]),
    justifyRow() {
      return this.isMobile ? "center" : "space-between";
    },
  },
  mounted() {
    this.$emit("mounted");
  },
  methods: {
    getSlotClass() {
      const slotClass = this.fillHeight ? "fill-height" : "";
      return this.removeSlotMargin
        ? `${slotClass} fill-width`
        : `${slotClass} wrapper-slot fill-width`;
    },
  },
};
</script>

<style lang="sass">
.subtitle-text
  font-size: 12px

.fill-width
  width: 100%

.wrapper-container
  align-content: flex-start

.container.fill-height
  align-items: start

.col-text
  display: flex
  flex-direction: column
  justify-content: flex-end

.breadcrumbs, .header-text, .wrapper-slot
  margin-left: 48px
  margin-right: 48px

.breadcrumbs
  margin-top: 24px

.heading
  background-color: var(--v-primary-base)
  background-size: auto
  background-position: 100% 50%
  background-repeat: no-repeat
  // min-height: 60px
  height: 100px

.header-text
  color: white
  font-family: 'Poppins'
  font-style: normal
  font-weight: 500
  font-size: 24px
  line-height: 120%

.img-heading
  width: 100%
  height: 100%
  object-fit: none

.img-heading-container
  height: 100px
  width: inherit

@media #{map-get($display-breakpoints, 'md-only')}
  .header-text, .breadcrumbs, .wrapper-slot
    margin-left: 32px
    margin-right: 32px

@media #{map-get($display-breakpoints, 'sm-only')}
  .header-text, .breadcrumbs, .wrapper-slot
    margin-left: 32px
    margin-right: 32px

@media #{map-get($display-breakpoints, 'xs-only')}
  .heading
    min-height: 100px

  .breadcrumbs
    margin-left: 0px

  .header-text
    margin-left: 8px
</style>
